import { JSX, useState } from 'react'

import { Button } from 'core-components/library/button'
import { NotificationController } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'
import { BaseCrud } from 'core-components/types'

import styles from '../../Table.module.scss'
import { IColumn, ITableProps, TTitleRenderFunction } from '../types'

interface IProps<P, R> {
  source: BaseCrud<P, R>
  columns: IColumn<P>[]
  isDataLoading: boolean
  tooltip?: () => JSX.Element
  titleRender?: TTitleRenderFunction
  exportColumns?: IColumn<P>[]
  onExportClick?: () => void
  exportFileName?: ITableProps['exportFileName']
}

export const Export = <P, R>({
  source,
  isDataLoading,
  columns,
  titleRender,
  exportColumns,
  tooltip,
  onExportClick,
  exportFileName,
}: IProps<P, R>) => {
  const [isExporting, setIsExporting] = useState<boolean>(false)
  const emptyTooltip = () => <div></div>

  return (
    <Tooltip tipContent={tooltip || emptyTooltip} disabled={!tooltip}>
      <Button
        className={styles.exportBtn}
        disabled={isDataLoading}
        __testId={'tableExportButton'}
        loading={isExporting}
        onClick={async () => {
          if (onExportClick) {
            onExportClick()
          } else {
            // @ts-ignore
            const exportMethod = source.export
            if (typeof exportMethod === 'function') {
              setIsExporting(true)
              await exportMethod(exportFileName, exportColumns ? exportColumns : columns)
              setIsExporting(false)
            } else {
              NotificationController.showError({
                message: `Something went wrong. Try export again or contact with administrator`,
              })
            }
          }
        }}
      >
        <>{(titleRender && titleRender('rowsCount', 'Export to XLSX')) || 'Export to XLSX'}</>
      </Button>
    </Tooltip>
  )
}
